import { formatDate, parseLocalDateString } from 'bernie-l10n';
import { format } from 'date-fns';
import { ActivityDetailBasic } from '../common/__generated__/api';
import { DetailQueryObject, SearchQueryObject } from '../stores';
import { equals } from './common-helper';

export function getIsoDateString(dateString: string) {
  let isoDateString = null;
  if (dateString) {
    const fragments = dateString.split('/');
    const month = fragments[0].length === 2 ? fragments[0] : `0${fragments[0]}`;
    const day = fragments[1].length === 2 ? fragments[1] : `0${fragments[1]}`;

    isoDateString = `${fragments[2]}-${month}-${day}`;
  }

  return isoDateString;
}

export function getIsoDateFromBexDate(date: ActivityDetailBasic.Date) {
  return getIsoDateString(`${date.month}/${date.day}/${date.year}`);
}

export function getDateObjectFromDateString(dateString: string, localDateFormat: string): Date {
  let isoDateObj = parseLocalDateString(dateString, { raw: localDateFormat }) as Date;
  if (!isoDateObj) {
    isoDateObj = parseLocalDateString(dateString, { raw: 'yyyy-MM-dd' }) as Date;
  }

  return isoDateObj;
}

export function getIsoFormatDateFromDateString(dateString: string, localDateFormat: string): string {
  const isoDateObj = dateString && getDateObjectFromDateString(dateString, localDateFormat);

  return isoDateObj && formatDate(isoDateObj, { raw: 'yyyy-MM-dd' });
}

export function isSrpAndISDatesSame(
  searchQuery: SearchQueryObject,
  detailQuery: DetailQueryObject,
  localDateFormat: string
): boolean {
  if (
    searchQuery.startDate === '' ||
    searchQuery.endDate === '' ||
    detailQuery.startDate === '' ||
    detailQuery.endDate === ''
  ) {
    return false;
  }
  const srpStartDate = getIsoFormatDateFromDateString(searchQuery.startDate, localDateFormat);
  const srpEndDate = getIsoFormatDateFromDateString(searchQuery.endDate, localDateFormat);

  const infositeStartDate = getIsoFormatDateFromDateString(detailQuery.startDate, localDateFormat);
  const infositeEndDate = getIsoFormatDateFromDateString(detailQuery.endDate, localDateFormat);

  return equals(srpStartDate, infositeStartDate) && equals(srpEndDate, infositeEndDate);
}

export function isValidDate(date: Date): boolean {
  return date && !isNaN(date.getTime());
}

export function isValidDateString(dateString: string, localDateFormat: string): boolean {
  let isValid = false;
  if (dateString) {
    const isoFormatDate = getDateObjectFromDateString(dateString, localDateFormat);
    isValid = isoFormatDate && isValidDate(isoFormatDate);
  }

  return isValid;
}

export function fromJSDateToISODateString(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function addDays(date: Date, days: number) {
  date.setDate(date.getDate() + days);

  return date;
}

export function getTodayDateBexFormat() {
  const today = new Date();

  return {
    day: today.getDate(),
    month: today.getMonth() + 1,
    year: today.getFullYear()
  };
}
